import { FORM_FIELDS } from '../../../constants';
import { api } from '../../client';

/** Загружает данные для profile-service из dadata */
export const getAddress = async (formData: FE.FormData) => {
    const registrationStreet = formData[FORM_FIELDS.REGISTRATION_STREET];
    const registrationApt = formData[FORM_FIELDS.REGISTRATION_APARTMENT];
    const registrationDadata = formData[FORM_FIELDS.REGISTRATION_DADATA_FULL];

    const residenceStreet = formData[FORM_FIELDS.RESIDENCE_STREET];
    const residenceApt = formData[FORM_FIELDS.RESIDENCE_APARTMENT];
    const residenceDadata = formData[FORM_FIELDS.RESIDENCE_DADATA_FULL];

    const sameRegistration = formData[FORM_FIELDS.RESIDENCE_SAME_REGISTRATION];

    const hasRegistrationDadata = Boolean(registrationDadata.data.fias_id);
    const hasResidenceDadata = Boolean(residenceDadata.data.fias_id);

    const registrationAddress = [registrationStreet, registrationApt].filter((v) => v).join(', кв ');
    const residenceAddress = [residenceStreet, residenceApt].filter((v) => v).join(', кв ');

    const [registrationSuggest, residenceSuggest] = await Promise.all([
        hasRegistrationDadata ? Promise.resolve(registrationDadata) : api.addressClean(registrationAddress),
        sameRegistration
            ? Promise.resolve(registrationDadata)
            : hasResidenceDadata
              ? Promise.resolve(residenceDadata)
              : api.addressClean(residenceAddress),
    ]);

    const getRegistrationDadataFull = () => {
        if (sameRegistration) {
            return registrationSuggest;
        }

        if (residenceSuggest) {
            return residenceSuggest;
        }
    };

    const registrationDadataFull = getRegistrationDadataFull();

    return {
        [FORM_FIELDS.REGISTRATION_DADATA_FULL]: registrationDadataFull,
        [FORM_FIELDS.RESIDENCE_DADATA_FULL]: registrationDadataFull,
    };
};
